import { useState } from 'react';

// eslint-disable-next-line import/no-cycle
import LoginModal from 'profile/login/LoginModal';

const NoCustomer = (props) => {
  const { reservationType } = props;
  const [modal, setModal] = useState(null);

  const handleLogin = () => {
    setModal('Login');
  };

  const pricingArray = reservationType.loyalty?.pricing || [];

  if (pricingArray.length === 0) {
    return null;
  }

  return (
    <>
      <div className="widget-pricing-nocustomer">
        <button type="button" onClick={handleLogin} className="c7-button">
          Member Login
        </button>
        <LoginModal modal={modal} setModal={setModal} />
      </div>
    </>
  );
};

export default NoCustomer;
